import * as types from "../types";
import * as _api from "../../api";
import { call, put, takeLatest } from "redux-saga/effects";
import { returnErrors } from "../actions/errorAction";
import { submitUpdateBidStatusFailure, submitUpdateBidStatusSuccess } from "../actions/submitUpdateBidStatus";

function* asyncsubmitUpdateBidStatusSaga(action){
    try{
        let updateBidStatusRes = yield call(_api.submitUpdateBidStatusApi,{
            accessToken: action.payload.accessToken,
            bid_status_id: action.payload.bid_status_id,
            bid_status: action.payload.bid_status,
        })
        yield put(submitUpdateBidStatusSuccess({updateBidStatusRes}))
    }catch(e){
        yield put(submitUpdateBidStatusFailure({error:e}))
        yield put(returnErrors({msg:e.message, status: true}))
    }
}

export default function* submitUpdateBidStatusSaga(){
    yield takeLatest(types.SUBMIT_UPDATE_BID_STATUS_REQUEST,asyncsubmitUpdateBidStatusSaga)
}